import { TransformDate } from '../../../shared/decorators/transform-date.decorator';
import { TransformFloat } from '../../../shared/decorators/transform-float.decorator';

export class SellVehicleActionDto {
  @TransformDate()
  soldAt?: Date | null;

  @TransformFloat()
  saleAskPrice?: number | null;

  @TransformFloat()
  saleSoldPrice?: number | null;

  @TransformDate()
  purchasedAt?: Date | null;

  @TransformFloat()
  purchaseListPrice?: number | null;

  @TransformFloat()
  purchasePaidPrice?: number | null;
}
